// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__19nOa","importantInfo":"styles_importantInfo__1Z_uz"};